import type { ReportConfig } from '../domain/report-config.types';

/**
 * Contract any Excel library must implement.
 * The application service depends ONLY on this interface,
 * never on a concrete library.
 */
export interface ExcelEngine {
  generate(config: ReportConfig): Promise<ArrayBuffer>;
}

export class ReportEngineError extends Error {
  constructor(
    message: string,
    public override readonly cause?: unknown,
  ) {
    super(message);
    this.name = 'ReportEngineError';
  }
}
